var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.open ? _vm.$style.active : '', _vm.$style.button],on:{"click":_vm.handleClick}},[_c('md-icon',{class:[_vm.open ? _vm.$style.openSidebar : '', _vm.$style.closedSidebar]},[_vm._v(" chevron_left ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }